import React from 'react'

import Base from '../_Base'

const Next = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M15.086 12 7.293 4.207l1.414-1.414 8.5 8.5.707.707-.707.707-8.5 8.5-1.414-1.414L15.086 12z"
    />
  </Base>
)

export default Next
